import { useApi } from "../../../swr/useApi";
import { api } from "../../api_client";
import type { ProductAttributeValueDto } from "../../../api";

/**
 * Returns RAM attribute values (e.g. 8 GB, 16 GB) from `/product-rams`.
 * Bypasses the generated SDK because RAM was just promoted from a custom
 * lookup model to a real product.attribute; the SDK's stale ProductRamDto
 * shape no longer matches the runtime payload (now ProductAttributeValueDto).
 * Will collapse back to the typed service after next `npm run generate:api`.
 */
export function useProductRams() {
  return useApi<ProductAttributeValueDto[]>("product-rams", async () =>
    api.get<ProductAttributeValueDto[]>("/api/v1/product-rams"),
  );
}
